import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'Starter',
    price: '299 €',
    prefix: 'ab',
    features: ['3 Visualisierungen', '1 Revision', '72h Lieferung', 'Standard Auflösung'],
    cta: 'Auswählen',
    highlighted: false
  }, {
    name: 'Pro',
    price: '799 €',
    prefix: 'ab',
    features: ['10 Visualisierungen', '3 Revisionen', '48h Lieferung', '4K Auflösung', 'Kommerzielle Nutzung'],
    cta: 'Auswählen',
    highlighted: true
  }, {
    name: 'Studio',
    price: 'auf Anfrage',
    prefix: '',
    features: ['Unbegrenzte Visuals', 'Dedizierter Ansprechpartner', 'Priority Support', 'Custom Branding', 'API Zugriff'],
    cta: 'Kontaktieren',
    highlighted: false
  }];
  return <section id="pricing" className="py-24 bg-[#FAFAFA]" data-id="element-180">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl sm:text-4xl font-semibold text-black mb-4" data-id="element-183">
            Preise & Pakete
          </h2>
          <p className="font-light text-neutral-500" data-id="element-184">
            Transparente Kosten für Projekte jeder Größe.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 items-start" data-id="element-185">
          {plans.map(plan => <div key={plan.name} className={`relative p-8 rounded-2xl transition-all duration-300 ${plan.highlighted ? 'bg-white border border-neutral-200 ring-1 ring-black scale-105 z-10' : 'bg-white border border-neutral-200 hover:border-neutral-300'}`} data-id="element-186">
              {plan.highlighted && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-187">
                  Beliebt
                </div>}

              <div className="mb-8" data-id="element-188">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-189">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-190">
                  {plan.prefix && <span className="text-sm text-neutral-400" data-id="element-191">
                      {plan.prefix}
                    </span>}
                  <span className="text-4xl font-semibold text-black" data-id="element-192">
                    {plan.price}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-193">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-194">
                    <Check className="w-5 h-5 text-black flex-shrink-0" data-id="element-195" />
                    <span className="font-light text-neutral-500 text-sm" data-id="element-196">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <Button fullWidth variant={plan.highlighted ? 'primary' : 'secondary'} onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-197">
                {plan.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}